<div class="trial-header">
  <div class="header">
    <div class="triangle" *ngIf="!visible" (click)="visible = true">&#x25B6;</div>
    <div class="triangle" *ngIf="visible" (click)="visible = false">&#x25BC;</div>
    <div class="trial-title">{{trial.trialId}}: {{trial.clinical_study.brief_title._text}}</div>
    <div class="link-to-ctgov" (click)="openTrial()">(Link)</div>
  </div>

  <div class="table" *ngIf="visible">
    <div class="row">
      <div class="key">NCTID</div>
      <div class="value">{{trial.trialId}}</div>
    </div>
    <div class="row">
      <div class="key">Title</div>
      <div class="value">{{trial.clinical_study.brief_title._text}}</div>
    </div>
    <!--<div class="row"><div class="key">Official Title</div><div class="value">{{trial.clinical_study.official_title._text}}</div></div>-->
    <!--<div class="row"><div class="key">Brief Summary</div><div class="value">{{trial.clinical_study.brief_summary.textblock._text}}</div></div>-->
    <div class="row">
      <div class="key">Status</div>
      <div class="value">{{trial.clinical_study.overall_status._text}}</div>
    </div>
    <div class="row">
      <div class="key">Phase</div>
      <div class="value">{{trial.clinical_study.phase._text}}</div>
    </div>
    <div class="row">
      <div class="key">Drugs</div>
      <div class="value">{{drugs}}</div>
    </div>
    <div class="row">
      <div class="key">Diseases</div>
      <div class="value">{{trial.clinical_study.condition._text}}</div>
    </div>
    <div class="row">
      <div class="key">Locations</div>
      <div class="value">{{locations}}</div>
    </div>
    <div class="row">
      <div class="key">Sponsor</div>
      <div class="value">{{trial.clinical_study.sponsors.lead_sponsor.agency._text}}</div>
    </div>
    <div class="row">
      <div class="key">Minimum age</div>
      <div class="value">{{trial.clinical_study.eligibility.minimum_age._text}}</div>
    </div>
    <div class="row">
      <div class="key">Maximum age</div>
      <div class="value">{{trial.clinical_study.eligibility.maximum_age._text}}</div>
    </div>
    <div class="row">
      <div class="key">Gender</div>
      <div class="value">{{trial.clinical_study.eligibility.gender._text}}</div>
    </div>
  </div>
</div>
